// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"3cd6ebee","253":"1ca3f821","529":"c7ddbd79"}[chunkId] + ".chunk.css";
};